"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var GRID_STYLE = {
  FIT_TO_SCREEN: 0,
  SET_ITEMS_PER_ROW: 1
};
var _default = GRID_STYLE;
exports["default"] = _default;